var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt10"},[_c('div',{staticClass:"tool_company img-body"},[_c('img',{attrs:{"src":_vm.property.cover_img?_vm.property.cover_img:'https://zaoxiang.oss-cn-hangzhou.aliyuncs.com/images/2024-02-27/b3fb768f35ac3438a6f27e1900ff378e.png'}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }